export enum SecondsEnum {
    One = 1000,
    Two = 2000,
    Four = 4000,
    Five = 5000,
}
